.ci{outline:none;}